import { createApp } from 'vue'
import { router } from '~/router/config'
import App from './App.vue'
import 'uno.css'
import '~/assets/reset.css'
import VueScan from 'z-vue-scan'
import dayjs from 'dayjs'
import '~/assets/iconfont/funnel/iconfont.css'
import '~/assets/iconfont/iconfont/iconfont.css'
import '~/assets/iconfont/icon/iconfont.css'
import '~/assets/iconfont/adicon/iconfont.css'
import '~/assets/iconfont/adClass/iconfont.css'
import '~/assets/iconfont/icon-query/iconfont.css'
import '~/assets/iconfont/LTVicon/iconfont.css'
import '~/assets/iconfont/icons/iconfont.css'
import '~/assets/iconfont/iconCustom/iconfont.css'
import '~/assets/iconfont/iconChannel/iconfont.css'
import "~/assets/iconfont/iconAttr/iconfont.css"
import "~/assets/iconfont/datalinkicon/iconfont.css"
import '~/assets/iconfont/play-icon/iconfont.css'
import '~/assets/iconfont/quality-icon/iconfont.css'
import relativeTime from 'dayjs/plugin/relativeTime'





dayjs.extend(relativeTime)
dayjs.locale('zh-cn', { weekStart: 1 })
const app = createApp(App)
app.config.warnHandler = (msg, vm, trace) => {
  if (msg.includes('Failed to resolve component')) {
    return // 忽略组件解析警告
  }
  console.warn(msg, trace)
}

// app.use(VueScan, {})
app.use(router)
app.mount('#app')
